import React from 'react';
import styled from 'styled-components';
import {
  BsFacebook,
  BsInstagram,
  BsYoutube,
  BsTwitterX,
  BsPinterest,
} from 'react-icons/bs';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import sharedStyles from '../styles';

const SocialIconsContainer = styled.div`
  margin-bottom: ${sharedStyles.spacing['spacing-lg']};

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.footer.socialIconFill};
    margin-right: ${sharedStyles.spacing['spacing-lg']};

    &:hover {
      fill: ${({ theme }) => theme.footer.socialIconFillHover};
    }
  }
`;

type FooterSocialIcons = {
  facebookBool?: boolean;
  facebookUrl?: string;
  instagramBool?: boolean;
  instagramUrl?: string;
  youtubeBool?: boolean;
  youtubeUrl?: string;
  twitterBool?: boolean;
  twitterUrl?: string;
  pinterestBool?: boolean;
  pinterestUrl?: string;
};

interface SocialIconsProps {
  footerSocialIcons: FooterSocialIcons;
}

const SocialIcons: React.FC<SocialIconsProps> = ({ footerSocialIcons }) => {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <SocialIconsContainer>
      {footerSocialIcons?.facebookBool && (
        <a
          href={footerSocialIcons.facebookUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={tt(s => s.footerCommon.facebookLinkAriaLabel)}
        >
          <BsFacebook />
        </a>
      )}

      {footerSocialIcons?.instagramBool && (
        <a
          href={footerSocialIcons.instagramUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={tt(s => s.footerCommon.instagramLinkAriaLabel)}
        >
          <BsInstagram />
        </a>
      )}

      {footerSocialIcons?.youtubeBool && (
        <a
          href={footerSocialIcons.youtubeUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={tt(s => s.footerCommon.youTubeLinkAriaLabel)}
        >
          <BsYoutube />
        </a>
      )}

      {footerSocialIcons?.twitterBool && (
        <a
          href={footerSocialIcons.twitterUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={tt(s => s.footerCommon.xLinkAriaLabel)}
        >
          <BsTwitterX />
        </a>
      )}

      {footerSocialIcons?.pinterestBool && (
        <a
          href={footerSocialIcons.pinterestUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={tt(s => s.footerCommon.pinterestLinkAriaLabel)}
        >
          <BsPinterest />
        </a>
      )}
    </SocialIconsContainer>
  );
};

export default SocialIcons;
